export { IndustryDescription } from './IndustryDescription';
